export const isMobileDeviceBrowser = navigator => {
  const regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  return regexp.test(navigator.userAgent);
  // fallback condition to force mobile version if device has multiple touch points
  /* || (!regexp.test(navigator.userAgent) && navigator.maxTouchPoints > 0); */
};